// SAZANSİGİLLER + KEDİ BALIKLARI + GÖKKUŞAĞI + KİLLİFİSH + DİĞER - balikVeritabani5.js
// Wikipedia Commons ücretsiz resimler kullanılmıştır

export const sazansigiller = {
  kategori: {
    id: 'sazansigiller',
    isim: 'Sazansigiller',
    emoji: '⚡',
    renk: '#ff9800',
    aciklama: 'Cyprinidae ailesi - Barb, Danio, Rasbora ve akrabaları'
  },
  baliklar: [
    {
      id: 'tiger-barb',
      isim: 'Kaplan Barb',
      latince: 'Puntigrus tetrazona',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/b/b9/Puntius_tetrazona.jpg/1280px-Puntius_tetrazona.jpg',
      zorluk: 'Kolay',
      genel: 'Sumatra ve Borneo kökenli. Aktif ve cesur. UYARI: Yüzgeç ısırıcı olabilir! Büyük grupta tutulmalı.',
      minLitre: 100,
      maxBoy: 7,
      sicaklik: { min: 22, max: 28 },
      ph: { min: 6.0, max: 7.5 },
      sertlik: { min: 5, max: 15 },
      yasam: '5-7 yıl',
      bolge: 'Orta',
      beslenme: 'Omnivor - Her şeyi yer.',
      uyumlu: ['Diğer Barb türleri', 'Danio', 'Corydoras', 'Pleco', 'Hızlı balıklar'],
      uyumsuz: ['Uzun yüzgeçli balıklar (Angel, Betta, Guppy)', 'Yavaş balıklar'],
      ureme: 'Yumurtlayan. Yumurtaları yer - ayrı üretim tankı gerekir.',
      eslesme: 'Grup içinde eşleşir.',
      grupSayisi: '8+ (büyük grupta yüzgeç ısırma azalır!)',
      disiErkek: 'Erkekler daha renkli, kırmızı burun. Dişiler daha tombul.',
      gorunus: 'Sarı-altın vücut, 4 siyah dikey bant. Kırmızı yüzgeçler ve burun. Green Tiger, Albino, GloFish varyasyonları.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'cherry-barb',
      isim: 'Cherry Barb',
      latince: 'Puntius titteya',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/c/c7/Puntius_titteya_male.jpg/1280px-Puntius_titteya_male.jpg',
      zorluk: 'Kolay',
      genel: 'Sri Lanka\'dan. En barışçıl Barb türlerinden. Erkekler kiraz kırmızısı. Bitkili tanklarda harika.',
      minLitre: 60,
      maxBoy: 5,
      sicaklik: { min: 22, max: 27 },
      ph: { min: 6.0, max: 7.5 },
      sertlik: { min: 5, max: 15 },
      yasam: '5-7 yıl',
      bolge: 'Orta ve Alt',
      beslenme: 'Omnivor',
      uyumlu: ['Tetralar', 'Rasbora', 'Corydoras', 'Küçük Gurami', 'Barışçıl topluluk balıkları'],
      uyumsuz: ['Büyük agresif balıklar'],
      ureme: 'Yumurtlayan.',
      eslesme: 'Erkekler kırmızılaşır ve gösteriş yapar.',
      grupSayisi: '6+ (en az 2 dişi / 1 erkek)',
      disiErkek: 'Erkekler parlak kiraz kırmızısı. Dişiler soluk, sarımsı-kahverengi.',
      gorunus: 'Erkekler parlak kiraz kırmızısı. Yatay koyu çizgi. Super Red varyasyonu daha kırmızı.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'rosy-barb',
      isim: 'Rosy Barb',
      latince: 'Pethia conchonius',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/d/d0/Rosy_barb_male.jpg/1280px-Rosy_barb_male.jpg',
      zorluk: 'Kolay',
      genel: 'Hindistan kökenli. Dayanıklı, soğuğa toleranslı. Isıtıcısız akvaryumlarda da yaşayabilir.',
      minLitre: 100,
      maxBoy: 10,
      sicaklik: { min: 16, max: 26 },
      ph: { min: 6.0, max: 8.0 },
      sertlik: { min: 5, max: 20 },
      yasam: '5-7 yıl',
      bolge: 'Orta',
      beslenme: 'Omnivor',
      uyumlu: ['Diğer Barb', 'Danio', 'Beyaz Bulut', 'Orta boy barışçıl balıklar'],
      uyumsuz: ['Tropikal hassas balıklar', 'Çok küçük balıklar'],
      ureme: 'Yumurtlayan. Kolay ürer.',
      eslesme: 'Erkekler parlak pembe olur.',
      grupSayisi: '6+',
      disiErkek: 'Erkekler pembe-kırmızı, dişiler gümüşi-sarımsı.',
      gorunus: 'Erkekler gül pembesi-kırmızı. Siyah yüzgeç noktaları. Long-fin varyasyonu uzun yüzgeçli.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'gold-barb',
      isim: 'Gold Barb',
      latince: 'Barbodes semifasciolatus',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/2/28/Gold_Barb.JPG/1280px-Gold_Barb.JPG',
      zorluk: 'Kolay',
      genel: 'Çin kökenli. Selektif üretimle altın sarısı form oluşturulmuş. Dayanıklı ve barışçıl.',
      minLitre: 80,
      maxBoy: 7,
      sicaklik: { min: 18, max: 26 },
      ph: { min: 6.0, max: 8.0 },
      sertlik: { min: 5, max: 20 },
      yasam: '5-7 yıl',
      bolge: 'Orta',
      beslenme: 'Omnivor',
      uyumlu: ['Diğer Barb', 'Danio', 'Tetra', 'Barışçıl topluluk balıkları'],
      uyumsuz: ['Çok küçük balıklar'],
      ureme: 'Yumurtlayan.',
      eslesme: 'Kolay ürer.',
      grupSayisi: '6+',
      disiErkek: 'Erkekler daha parlak, daha ince. Dişiler tombul.',
      gorunus: 'Altın sarısı vücut, siyah benekler veya soluk bantlar.',
      kaynaklar: ['fishbase.org']
    },
    {
      id: 'odessa-barb',
      isim: 'Odessa Barb',
      latince: 'Pethia padamya',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/5f/Pethia_padamya.jpg/1280px-Pethia_padamya.jpg',
      zorluk: 'Kolay',
      genel: 'Myanmar kökenli. Erkeklerin parlak kırmızı bandı çok çekici. Nispeten yeni tanımlanan tür (2008).',
      minLitre: 80,
      maxBoy: 5,
      sicaklik: { min: 22, max: 26 },
      ph: { min: 6.5, max: 7.5 },
      sertlik: { min: 5, max: 15 },
      yasam: '5 yıl',
      bolge: 'Orta',
      beslenme: 'Omnivor',
      uyumlu: ['Diğer Barb', 'Danio', 'Tetra', 'Rasbora'],
      uyumsuz: ['Çok yavaş balıklar'],
      ureme: 'Yumurtlayan.',
      eslesme: 'Erkekler renkli gösteriş yapar.',
      grupSayisi: '6+',
      disiErkek: 'Erkekler yatay parlak kırmızı bant. Dişiler soluk.',
      gorunus: 'Gümüşi vücut, erkeklerde parlak kırmızı yatay bant. Siyah benekler.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'denison-barb',
      isim: 'Denison Barb (Kırmızı Çizgili)',
      latince: 'Sahyadria denisonii',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/3/37/Puntius_denisonii.jpg/1280px-Puntius_denisonii.jpg',
      zorluk: 'Orta',
      genel: 'Roseline Shark, Denison\'s Barb. Hindistan\'ın Western Ghats\'ından. Çok güzel ama pahalı.',
      minLitre: 200,
      maxBoy: 15,
      sicaklik: { min: 18, max: 25 },
      ph: { min: 6.5, max: 7.5 },
      sertlik: { min: 5, max: 15 },
      yasam: '5-8 yıl',
      bolge: 'Orta',
      beslenme: 'Omnivor',
      uyumlu: ['Barb', 'Danio', 'Tetra', 'Barışçıl orta-büyük balıklar'],
      uyumsuz: ['Çok küçük balıklar', 'Agresif cikletler'],
      ureme: 'Yumurtlayan. Akvaryumda çok nadir.',
      eslesme: 'Ticari olarak hormon ile üretilir.',
      grupSayisi: '6+ (sürü)',
      disiErkek: 'Ayrımı zor. Dişiler biraz daha tombul.',
      gorunus: 'Gümüşi vücut, siyah yatay çizgi, bunun üstünde parlak kırmızı çizgi. Sarı-siyah kuyruk.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'zebra-danio',
      isim: 'Zebra Danio',
      latince: 'Danio rerio',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/ac/Zebrafisch.jpg/1280px-Zebrafisch.jpg',
      zorluk: 'Kolay',
      genel: 'Hindistan kökenli. Bilimde model organizma. Çok dayanıklı, hızlı yüzücü. Başlangıç için ideal.',
      minLitre: 60,
      maxBoy: 5,
      sicaklik: { min: 18, max: 26 },
      ph: { min: 6.0, max: 8.0 },
      sertlik: { min: 5, max: 20 },
      yasam: '3-5 yıl',
      bolge: 'Üst ve Orta',
      beslenme: 'Omnivor - Her şeyi yer.',
      uyumlu: ['Çoğu topluluk balığı', 'Barb', 'Tetra', 'Corydoras', 'Barışçıl balıklar'],
      uyumsuz: ['Uzun yüzgeçli yavaş balıklar', 'Çok büyük balıklar'],
      ureme: 'Yumurtlayan. Çok kolay ürer.',
      eslesme: 'Şafakta yumurtlar.',
      grupSayisi: '6+ (sürü)',
      disiErkek: 'Dişiler daha tombul. Erkekler daha ince, daha sarı.',
      gorunus: 'Mavi-mor yatay çizgiler. Leopard Danio (benekli), Long-fin, GloFish (floresan) varyasyonları.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'pearl-danio',
      isim: 'Pearl Danio',
      latince: 'Danio albolineatus',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/f/f0/Danio_albolineatus.jpg/1280px-Danio_albolineatus.jpg',
      zorluk: 'Kolay',
      genel: 'Güneydoğu Asya\'dan. İnci parlaklığı ile güzel. Zebra Danio kadar dayanıklı.',
      minLitre: 60,
      maxBoy: 6,
      sicaklik: { min: 20, max: 26 },
      ph: { min: 6.0, max: 8.0 },
      sertlik: { min: 5, max: 20 },
      yasam: '3-5 yıl',
      bolge: 'Üst ve Orta',
      beslenme: 'Omnivor',
      uyumlu: ['Diğer Danio', 'Tetra', 'Barb', 'Barışçıl topluluk balıkları'],
      uyumsuz: ['Yavaş, uzun yüzgeçli balıklar'],
      ureme: 'Yumurtlayan.',
      eslesme: 'Kolay ürer.',
      grupSayisi: '6+ (sürü)',
      disiErkek: 'Erkekler daha ince, daha renkli. Dişiler tombul.',
      gorunus: 'İnci parlaklığı, pembe-mavi yansımalar. Turuncu yatay çizgi.',
      kaynaklar: ['fishbase.org']
    },
    {
      id: 'celestial-pearl-danio',
      isim: 'Celestial Pearl Danio (Galaxy Rasbora)',
      latince: 'Danio margaritatus',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/57/Danio_margaritatus.jpg/1280px-Danio_margaritatus.jpg',
      zorluk: 'Orta',
      genel: 'Myanmar\'dan 2006\'da keşfedildi. Çok küçük ve güzel. Nano tanklarda popüler.',
      minLitre: 40,
      maxBoy: 3,
      sicaklik: { min: 20, max: 26 },
      ph: { min: 6.5, max: 7.5 },
      sertlik: { min: 5, max: 15 },
      yasam: '3-5 yıl',
      bolge: 'Orta',
      beslenme: 'Omnivor - Küçük yemler.',
      uyumlu: ['Küçük Tetralar', 'Karides', 'Otocinclus', 'Diğer nano balıklar'],
      uyumsuz: ['Büyük balıklar', 'Hızlı yem rakipleri'],
      ureme: 'Yumurtlayan. Yosun ve bitkilere.',
      eslesme: 'Erkekler gösteriş yapar.',
      grupSayisi: '6+ (en az 2 dişi / erkek)',
      disiErkek: 'Erkekler daha renkli, kırmızı yüzgeçler. Dişiler daha soluk.',
      gorunus: 'Koyu mavi vücut, inci beyazı noktalar (galaksi). Kırmızı-turuncu yüzgeçler.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'white-cloud',
      isim: 'Beyaz Bulut Dağ Balığı',
      latince: 'Tanichthys albonubes',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/2/2c/White_Cloud_Mountain_Minnow_Tanichthys_albonubes_2900px.jpg/1280px-White_Cloud_Mountain_Minnow_Tanichthys_albonubes_2900px.jpg',
      zorluk: 'Kolay',
      genel: 'Çin dağlarından. Soğuk suya çok toleranslı - ısıtıcısız akvaryum için ideal. "Fakir adamın Neonu" lakabı.',
      minLitre: 40,
      maxBoy: 4,
      sicaklik: { min: 12, max: 24 },
      ph: { min: 6.0, max: 8.0 },
      sertlik: { min: 5, max: 20 },
      yasam: '5-7 yıl',
      bolge: 'Üst ve Orta',
      beslenme: 'Omnivor',
      uyumlu: ['Diğer soğuk su balıkları', 'Danio', 'Rosy Barb', 'Hillstream Loach'],
      uyumsuz: ['Tropikal balıklar (sıcaklık uyumsuz)', 'Büyük balıklar'],
      ureme: 'Yumurtlayan. Kolay ürer.',
      eslesme: 'Bitkiler arasına yumurta saçar.',
      grupSayisi: '6+ (sürü)',
      disiErkek: 'Erkekler daha renkli, daha ince.',
      gorunus: 'Gümüşi-yeşil vücut, kırmızı kuyruk ve burun, beyaz-mavi yatay çizgi. Gold, Meteor (long-fin) varyasyonları.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'scissortail-rasbora',
      isim: 'Scissortail Rasbora',
      latince: 'Rasbora trilineata',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/9/91/Rasbora_trilineata.jpg/1280px-Rasbora_trilineata.jpg',
      zorluk: 'Kolay',
      genel: 'Güneydoğu Asya\'dan. Makas kuyruk hareketi ile tanınır. Dayanıklı ve aktif.',
      minLitre: 100,
      maxBoy: 10,
      sicaklik: { min: 22, max: 28 },
      ph: { min: 6.0, max: 7.5 },
      sertlik: { min: 5, max: 15 },
      yasam: '5-7 yıl',
      bolge: 'Orta ve Üst',
      beslenme: 'Omnivor',
      uyumlu: ['Diğer Rasbora', 'Tetra', 'Barb', 'Gurami', 'Barışçıl balıklar'],
      uyumsuz: ['Küçük nano balıklar', 'Agresif türler'],
      ureme: 'Yumurtlayan.',
      eslesme: 'Bitkilere yumurta saçar.',
      grupSayisi: '6+ (sürü)',
      disiErkek: 'Dişiler daha tombul.',
      gorunus: 'Gümüşi vücut, çatallı kuyrukta siyah-sarı desen. Kuyruk açılıp kapanırken makas hareketi.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'chili-rasbora',
      isim: 'Chili Rasbora',
      latince: 'Boraras brigittae',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/8/8c/Boraras_brigittae.jpg/1280px-Boraras_brigittae.jpg',
      zorluk: 'Orta',
      genel: 'Endonezya\'dan. Çok küçük, çok kırmızı. Nano tankların yıldızı.',
      minLitre: 20,
      maxBoy: 2,
      sicaklik: { min: 24, max: 28 },
      ph: { min: 5.0, max: 7.0 },
      sertlik: { min: 2, max: 10 },
      yasam: '4-8 yıl',
      bolge: 'Orta',
      beslenme: 'Omnivor - Çok küçük yemler, mikro pellet.',
      uyumlu: ['Diğer Boraras', 'Karides', 'Otocinclus', 'Küçük Corydoras'],
      uyumsuz: ['Tüm büyük balıklar'],
      ureme: 'Yumurtlayan.',
      eslesme: 'Bitkili tankta spontan.',
      grupSayisi: '8+ (sürü)',
      disiErkek: 'Erkekler daha kırmızı.',
      gorunus: 'Minik, parlak kırmızı vücut. Koyu yatay çizgi.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'bala-shark',
      isim: 'Bala Köpekbalığı',
      latince: 'Balantiocheilos melanopterus',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/0/08/Balantiocheilos_melanopterus_-_Karlsruhe_Zoo_01.jpg/1280px-Balantiocheilos_melanopterus_-_Karlsruhe_Zoo_01.jpg',
      zorluk: 'Orta',
      genel: 'Güneydoğu Asya\'dan. Köpekbalığı değil, büyük bir sazan. UYARI: 35cm olur, çok büyük tank gerekir!',
      minLitre: 500,
      maxBoy: 35,
      sicaklik: { min: 24, max: 28 },
      ph: { min: 6.5, max: 7.5 },
      sertlik: { min: 5, max: 15 },
      yasam: '10+ yıl',
      bolge: 'Orta',
      beslenme: 'Omnivor',
      uyumlu: ['Büyük Barb', 'Büyük Tetra', 'Büyük barışçıl balıklar'],
      uyumsuz: ['Küçük balıklar (stres verir)', 'Agresif cikletler'],
      ureme: 'Yumurtlayan. Akvaryumda üremez.',
      eslesme: 'Ticari olarak hormon ile.',
      grupSayisi: '3+ (stres azaltır)',
      disiErkek: 'Ayrımı zor.',
      gorunus: 'Gümüşi vücut, siyah kenarlı yüzgeçler. Köpekbalığı şekilli sırt yüzgeci.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'redtail-shark',
      isim: 'Kırmızı Kuyruklu Köpekbalığı',
      latince: 'Epalzeorhynchos bicolor',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/9/97/Epalzeorhynchos_bicolor.jpg/1280px-Epalzeorhynchos_bicolor.jpg',
      zorluk: 'Orta',
      genel: 'Tayland\'dan. Kadife siyah vücut, parlak kırmızı kuyruk. Territorial, özellikle kendi türüne karşı!',
      minLitre: 150,
      maxBoy: 15,
      sicaklik: { min: 22, max: 27 },
      ph: { min: 6.5, max: 7.5 },
      sertlik: { min: 5, max: 15 },
      yasam: '5-8 yıl',
      bolge: 'Alt',
      beslenme: 'Omnivor - Alg, sebze, pellet.',
      uyumlu: ['Üst/orta yüzen balıklar', 'Hızlı Tetralar', 'Barb'],
      uyumsuz: ['Diğer Redtail Shark', 'Rainbow Shark', 'Dip balıkları'],
      ureme: 'Yumurtlayan. Akvaryumda çok nadir.',
      eslesme: 'Ticari hormon.',
      grupSayisi: 'SADECE TEK!',
      disiErkek: 'Ayrımı zor. Dişiler daha tombul.',
      gorunus: 'Kadife siyah vücut, parlak kırmızı kuyruk. Albino varyasyonu var.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'rainbow-shark',
      isim: 'Rainbow Shark',
      latince: 'Epalzeorhynchos frenatum',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/3/33/Epalzeorhynchos_frenatum.jpg/1280px-Epalzeorhynchos_frenatum.jpg',
      zorluk: 'Orta',
      genel: 'Redtail\'e benzer ama tüm yüzgeçleri kırmızı. Aynı şekilde territorial.',
      minLitre: 150,
      maxBoy: 15,
      sicaklik: { min: 22, max: 27 },
      ph: { min: 6.5, max: 7.5 },
      sertlik: { min: 5, max: 15 },
      yasam: '5-8 yıl',
      bolge: 'Alt',
      beslenme: 'Omnivor',
      uyumlu: ['Üst yüzen balıklar', 'Hızlı balıklar'],
      uyumsuz: ['Kendi türü', 'Redtail Shark', 'Dip balıkları'],
      ureme: 'Yumurtlayan. Akvaryumda çok nadir.',
      eslesme: 'Ticari hormon.',
      grupSayisi: 'SADECE TEK!',
      disiErkek: 'Ayrımı zor.',
      gorunus: 'Koyu gri vücut, TÜM yüzgeçler kırmızı-turuncu. Albino (GloFish dahil) varyasyonları.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'siamese-algae-eater',
      isim: 'Siyam Alg Yiyici (SAE)',
      latince: 'Crossocheilus oblongus',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/1/17/Crossocheilus_oblongus.jpg/1280px-Crossocheilus_oblongus.jpg',
      zorluk: 'Kolay',
      genel: 'Gerçek SAE. Siyah sakal algini yiyen NADİR balıklardan biri. Çok faydalı.',
      minLitre: 150,
      maxBoy: 15,
      sicaklik: { min: 24, max: 28 },
      ph: { min: 6.0, max: 7.5 },
      sertlik: { min: 5, max: 15 },
      yasam: '10 yıl',
      bolge: 'Alt',
      beslenme: 'Herbivor ağırlıklı - ALG, spirulina, sebze. Yaşlandıkça tembelleşir.',
      uyumlu: ['Çoğu topluluk balığı'],
      uyumsuz: ['Yavaş, uzun yüzgeçli balıklar (yaşlandıkça)'],
      ureme: 'Yumurtlayan. Akvaryumda üremez.',
      eslesme: '-',
      grupSayisi: 'Tek veya grup',
      disiErkek: 'Ayrımı çok zor.',
      gorunus: 'Gümüşi-bej, belirgin siyah yatay çizgi (kuyruk ucuna kadar uzanır). Çin Alg Yiyici ile karıştırılır!',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    }
  ]
};

export const kediBaliklari = {
  kategori: {
    id: 'kedi-baliklari',
    isim: 'Kedi Balıkları',
    emoji: '🐱',
    renk: '#795548',
    aciklama: 'Siluriformes takımı - Corydoras, Pleco, Otocinclus ve dip sakinleri'
  },
  baliklar: [
    {
      id: 'corydoras-panda',
      isim: 'Panda Corydoras',
      latince: 'Corydoras panda',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/8/8a/Corydoras_panda.jpg/1280px-Corydoras_panda.jpg',
      zorluk: 'Kolay',
      genel: 'Peru\'dan. Göz çevresindeki siyah lekeler panda ayısına benzer. En popüler Corydoras türlerinden.',
      minLitre: 60,
      maxBoy: 5,
      sicaklik: { min: 20, max: 25 },
      ph: { min: 6.0, max: 7.5 },
      sertlik: { min: 2, max: 12 },
      yasam: '10+ yıl',
      bolge: 'Alt',
      beslenme: 'Omnivor - Dip tableti, canlı/dondurulmuş yem, batan yemler.',
      uyumlu: ['Hemen hemen TÜM barışçıl balıklar!'],
      uyumsuz: ['Agresif dip balıkları', 'Çok büyük cikletler'],
      ureme: 'Yumurtlayan. Serin su değişimi tetikler.',
      eslesme: 'T pozisyonunda çiftleşir. Yumurtaları cama ve bitkilere yapıştırır.',
      grupSayisi: '6+ (sosyal balık!)',
      disiErkek: 'Dişiler daha iri ve yuvarlak (üstten bakınca).',
      gorunus: 'Krem rengi vücut, gözlerde siyah panda maskesi, sırt ve kuyrukta siyah leke.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'corydoras-sterbai',
      isim: 'Sterbai Corydoras',
      latince: 'Corydoras sterbai',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/4/44/Corydoras_sterbai.jpg/1280px-Corydoras_sterbai.jpg',
      zorluk: 'Kolay',
      genel: 'Brezilya\'dan. Sıcak suya toleranslı - Discus ile uyumlu tek Corydoras! Çok popüler.',
      minLitre: 80,
      maxBoy: 7,
      sicaklik: { min: 24, max: 30 },
      ph: { min: 6.0, max: 7.5 },
      sertlik: { min: 2, max: 15 },
      yasam: '10+ yıl',
      bolge: 'Alt',
      beslenme: 'Omnivor - Dip tableti, canlı yem.',
      uyumlu: ['Discus!', 'Tetralar', 'Angel', 'Tüm barışçıl balıklar'],
      uyumsuz: ['Agresif dip balıkları'],
      ureme: 'Yumurtlayan.',
      eslesme: 'T pozisyonu.',
      grupSayisi: '6+',
      disiErkek: 'Dişiler daha iri.',
      gorunus: 'Koyu kahverengi üzerinde beyaz noktalar. TURUNCU göğüs yüzgeçleri - tanımlayıcı özellik!',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'corydoras-aeneus',
      isim: 'Bronz Corydoras',
      latince: 'Corydoras aeneus',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/c/c6/Corydoras_aeneus.jpg/1280px-Corydoras_aeneus.jpg',
      zorluk: 'Kolay',
      genel: 'En yaygın ve en dayanıklı Corydoras. Güney Amerika\'da geniş yayılım. Başlangıç için ideal.',
      minLitre: 60,
      maxBoy: 7,
      sicaklik: { min: 22, max: 28 },
      ph: { min: 6.0, max: 8.0 },
      sertlik: { min: 5, max: 20 },
      yasam: '10+ yıl',
      bolge: 'Alt',
      beslenme: 'Omnivor',
      uyumlu: ['Tüm barışçıl balıklar'],
      uyumsuz: ['Agresif dip balıkları'],
      ureme: 'Yumurtlayan. Çok kolay ürer.',
      eslesme: 'T pozisyonu.',
      grupSayisi: '6+',
      disiErkek: 'Dişiler daha iri ve yuvarlak.',
      gorunus: 'Bronz-yeşil metalik parlaklık. Albino, Green Laser varyasyonları.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'corydoras-julii',
      isim: 'Julii Corydoras',
      latince: 'Corydoras julii',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/c/cd/Corydoras_trilineatus.jpg/1280px-Corydoras_trilineatus.jpg',
      zorluk: 'Kolay',
      genel: 'Leopar deseni. NOT: Satılan çoğu "Julii" aslında C. trilineatus\'tur. Gerçek Julii nadir.',
      minLitre: 60,
      maxBoy: 6,
      sicaklik: { min: 22, max: 26 },
      ph: { min: 6.0, max: 7.5 },
      sertlik: { min: 2, max: 12 },
      yasam: '10+ yıl',
      bolge: 'Alt',
      beslenme: 'Omnivor',
      uyumlu: ['Tüm barışçıl balıklar'],
      uyumsuz: ['Agresif dip balıkları'],
      ureme: 'Yumurtlayan.',
      eslesme: 'T pozisyonu.',
      grupSayisi: '6+',
      disiErkek: 'Dişiler daha iri.',
      gorunus: 'Beyaz üzerinde siyah noktalar ve labirent çizgiler. Başta noktalar ayrı (trilineatus\'ta birleşik çizgi).',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'corydoras-pygmaeus',
      isim: 'Pygmy Corydoras',
      latince: 'Corydoras pygmaeus',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/a9/Corydoras_pygmaeus.jpg/1280px-Corydoras_pygmaeus.jpg',
      zorluk: 'Orta',
      genel: 'Cüce Corydoras. Çok küçük, orta suda da yüzer. Nano tanklar için ideal.',
      minLitre: 40,
      maxBoy: 3,
      sicaklik: { min: 22, max: 26 },
      ph: { min: 6.0, max: 7.5 },
      sertlik: { min: 2, max: 12 },
      yasam: '3-5 yıl',
      bolge: 'Alt ve Orta',
      beslenme: 'Omnivor - Küçük yemler.',
      uyumlu: ['Nano balıklar', 'Küçük Tetralar', 'Karides'],
      uyumsuz: ['Büyük balıklar'],
      ureme: 'Yumurtlayan.',
      eslesme: 'T pozisyonu.',
      grupSayisi: '10+ (sürü)',
      disiErkek: 'Dişiler daha tombul.',
      gorunus: 'Minik. Gümüşi vücut, siyah yatay çizgi. Diğer Corydoras\'lardan farklı olarak sık sık yüzer.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'corydoras-habrosus',
      isim: 'Salt & Pepper Corydoras',
      latince: 'Corydoras habrosus',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/8/84/Corydoras_habrosus.jpg/1280px-Corydoras_habrosus.jpg',
      zorluk: 'Orta',
      genel: 'Diğer cüce Corydoras. Tuz-biber benekli. Dip bölgesinde kalır (pygmaeus\'tan farklı).',
      minLitre: 40,
      maxBoy: 3,
      sicaklik: { min: 22, max: 26 },
      ph: { min: 6.0, max: 7.5 },
      sertlik: { min: 2, max: 12 },
      yasam: '3-5 yıl',
      bolge: 'Alt',
      beslenme: 'Omnivor - Küçük yemler.',
      uyumlu: ['Nano balıklar', 'Karides'],
      uyumsuz: ['Büyük balıklar'],
      ureme: 'Yumurtlayan.',
      eslesme: 'T pozisyonu.',
      grupSayisi: '8+',
      disiErkek: 'Dişiler daha tombul.',
      gorunus: 'Küçük. Açık kahverengi üzerinde koyu benekler - tuz biber görünümü.',
      kaynaklar: ['fishbase.org']
    },
    {
      id: 'bristlenose-pleco',
      isim: 'Bristlenose Pleco',
      latince: 'Ancistrus sp.',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/b/b4/Ancistrus_sp.jpg/1280px-Ancistrus_sp.jpg',
      zorluk: 'Kolay',
      genel: 'Bushy Nose Pleco. ALG TEMİZLEYİCİ olarak çok popüler. Common Pleco\'dan küçük kalır!',
      minLitre: 100,
      maxBoy: 15,
      sicaklik: { min: 22, max: 28 },
      ph: { min: 6.0, max: 7.5 },
      sertlik: { min: 5, max: 15 },
      yasam: '10-15 yıl',
      bolge: 'Alt',
      beslenme: 'Herbivor ağırlıklı - Alg, sebze (kabak, salatalık), alg tabletleri.',
      uyumlu: ['Hemen hemen tüm topluluk balıkları'],
      uyumsuz: ['Diğer Pleco (bölge kavgası)'],
      ureme: 'Mağara yumurtlayıcı. Erkek yumurtaları korur.',
      eslesme: 'Erkek mağara sahiplenir.',
      grupSayisi: '1 veya çift (büyük tankta)',
      disiErkek: 'ERKEKLERDE burnun her yerinde diken/tentakül. Dişilerde az veya hiç yok.',
      gorunus: 'Zırhlı görünüm, vantuz ağız. Erkeklerin burnu dikenlerle kaplı. Brown, Albino, Super Red, Longfin varyasyonları.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'common-pleco',
      isim: 'Common Pleco',
      latince: 'Hypostomus plecostomus',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/c/c6/Hypostomus_plecostomus.jpg/1280px-Hypostomus_plecostomus.jpg',
      zorluk: 'Kolay',
      genel: 'UYARI: 50cm\'e kadar büyür! Mağazada küçük satılır ama DEV olur. Bristlenose tercih edin.',
      minLitre: 500,
      maxBoy: 50,
      sicaklik: { min: 22, max: 28 },
      ph: { min: 6.5, max: 8.0 },
      sertlik: { min: 5, max: 20 },
      yasam: '15-20 yıl',
      bolge: 'Alt',
      beslenme: 'Omnivor - Yaşlandıkça daha çok protein ister, alg yemez.',
      uyumlu: ['Büyük balıklar'],
      uyumsuz: ['Küçük tanklar!', 'Yavaş balıklar (mukus yaladığı iddia edilir)'],
      ureme: 'Akvaryumda üremez.',
      eslesme: '-',
      grupSayisi: 'Tek',
      disiErkek: 'Ayrımı çok zor.',
      gorunus: 'Büyük, zırhlı, kahverengi-gri benekli. Vantuz ağız.',
      kaynaklar: ['fishbase.org']
    },
    {
      id: 'zebra-pleco',
      isim: 'Zebra Pleco',
      latince: 'Hypancistrus zebra',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/f/f2/Hypancistrus_zebra.jpg/1280px-Hypancistrus_zebra.jpg',
      zorluk: 'Zor',
      genel: 'L046. Brezilya Xingu Nehri\'ne endemik. Çok nadir ve pahalı! İhracatı yasak.',
      minLitre: 100,
      maxBoy: 8,
      sicaklik: { min: 26, max: 32 },
      ph: { min: 6.0, max: 7.0 },
      sertlik: { min: 2, max: 8 },
      yasam: '10-15 yıl',
      bolge: 'Alt',
      beslenme: 'Karnivor ağırlıklı - Protein yemler, dondurulmuş yem. ALG YEMEZ!',
      uyumlu: ['Barışçıl, yüksek sıcaklık seven balıklar'],
      uyumsuz: ['Yem rakipleri', 'Agresif dip balıkları'],
      ureme: 'Mağara yumurtlayıcı.',
      eslesme: 'Erkek yumurtaları korur.',
      grupSayisi: '1 veya küçük grup',
      disiErkek: 'Erkeklerin kafası daha geniş.',
      gorunus: 'Dramatik siyah-beyaz zebra çizgileri. Çok çarpıcı.',
      kaynaklar: ['fishbase.org', 'planetcatfish.com']
    },
    {
      id: 'clown-pleco',
      isim: 'Clown Pleco',
      latince: 'Panaqolus maccus',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/9/99/Panaqolus_maccus.jpg/1280px-Panaqolus_maccus.jpg',
      zorluk: 'Kolay',
      genel: 'L104/L162. Küçük kalan pleco. Odun yemeye İHTİYACI VAR - selüloz sindirimi için.',
      minLitre: 80,
      maxBoy: 10,
      sicaklik: { min: 24, max: 28 },
      ph: { min: 6.5, max: 7.5 },
      sertlik: { min: 5, max: 15 },
      yasam: '10-12 yıl',
      bolge: 'Alt',
      beslenme: 'Herbivor - ODUN ŞART! Ayrıca sebze, alg tableti.',
      uyumlu: ['Çoğu topluluk balığı'],
      uyumsuz: ['Diğer Pleco'],
      ureme: 'Mağara yumurtlayıcı.',
      eslesme: 'Odun içindeki boşluklarda.',
      grupSayisi: 'Tek veya çift',
      disiErkek: 'Ayrımı zor.',
      gorunus: 'Koyu kahverengi üzerinde sarı-turuncu dalgalı çizgiler.',
      kaynaklar: ['fishbase.org', 'planetcatfish.com']
    },
    {
      id: 'otocinclus',
      isim: 'Otocinclus (Oto)',
      latince: 'Otocinclus vittatus',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/8/84/Otocinclus_vittatus.jpg/1280px-Otocinclus_vittatus.jpg',
      zorluk: 'Orta',
      genel: 'Dwarf Suckermouth. Küçük alg temizleyici. Bitkili tanklarda mükemmel. Hassas - olgun tanklarda tut.',
      minLitre: 60,
      maxBoy: 5,
      sicaklik: { min: 22, max: 26 },
      ph: { min: 6.0, max: 7.5 },
      sertlik: { min: 5, max: 15 },
      yasam: '3-5 yıl',
      bolge: 'Alt ve yüzeyler',
      beslenme: 'Herbivor - Alg, blanched sebze. Tank olgun olmalı (yeterli alg).',
      uyumlu: ['Tetralar', 'Rasbora', 'Corydoras', 'Karides', 'TÜM barışçıl küçük balıklar'],
      uyumsuz: ['Büyük/agresif balıklar', 'Yeni kurulan tanklar (açlık)'],
      ureme: 'Yumurtlayan. Akvaryumda zor.',
      eslesme: 'Cam ve yapraklara yumurta.',
      grupSayisi: '6+ (sosyal)',
      disiErkek: 'Dişiler daha tombul.',
      gorunus: 'Küçük, zırhlı, vantuz ağızlı. Gümüşi-yeşil, siyah yatay çizgi.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'glass-catfish',
      isim: 'Cam Kedi Balığı',
      latince: 'Kryptopterus vitreolus',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/3/39/Kryptopterus_vitreolus.jpg/1280px-Kryptopterus_vitreolus.jpg',
      zorluk: 'Orta',
      genel: 'Şeffaf vücut - iskelet ve organlar görünür! Güneydoğu Asya\'dan. Hassas, iyi su kalitesi gerekir.',
      minLitre: 100,
      maxBoy: 8,
      sicaklik: { min: 24, max: 28 },
      ph: { min: 6.0, max: 7.0 },
      sertlik: { min: 3, max: 10 },
      yasam: '5-8 yıl',
      bolge: 'Orta',
      beslenme: 'Karnivor - Canlı ve dondurulmuş yem tercih eder.',
      uyumlu: ['Barışçıl orta boy balıklar', 'Tetralar', 'Rasbora'],
      uyumsuz: ['Agresif balıklar', 'Çok aktif balıklar'],
      ureme: 'Yumurtlayan. Akvaryumda çok nadir.',
      eslesme: '-',
      grupSayisi: '6+ (sürü - tek strese girer!)',
      disiErkek: 'Ayrımı çok zor.',
      gorunus: 'Tamamen şeffaf vücut! İskelet ve organlar görünür. Hafif gökkuşağı yansıması.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'pictus-catfish',
      isim: 'Pictus Catfish',
      latince: 'Pimelodus pictus',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/3/3b/Pimelodus_pictus.jpg/1280px-Pimelodus_pictus.jpg',
      zorluk: 'Orta',
      genel: 'Uzun bıyıkları ve benekli görünümüyle popüler. Aktif yüzücü. Gece aktif.',
      minLitre: 200,
      maxBoy: 12,
      sicaklik: { min: 22, max: 28 },
      ph: { min: 6.5, max: 7.5 },
      sertlik: { min: 5, max: 15 },
      yasam: '8-10 yıl',
      bolge: 'Alt ve Orta',
      beslenme: 'Omnivor - Batan pellet, canlı yem, dondurulmuş yem.',
      uyumlu: ['Eşit boy, dayanıklı balıklar'],
      uyumsuz: ['Küçük balıklar (yem olur)', 'Yavaş balıklar'],
      ureme: 'Akvaryumda üremez.',
      eslesme: '-',
      grupSayisi: '3+ (sosyal)',
      disiErkek: 'Dişiler daha tombul.',
      gorunus: 'Gümüşi vücut, siyah benekler. Çok uzun beyaz bıyıklar. Dikkatli - sırt dikeni zehirli!',
      kaynaklar: ['fishbase.org', 'planetcatfish.com']
    },
    {
      id: 'synodontis-petricola',
      isim: 'Synodontis Petricola',
      latince: 'Synodontis petricola',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/a5/Synodontis_petricola.jpg/1280px-Synodontis_petricola.jpg',
      zorluk: 'Orta',
      genel: 'Cuckoo Catfish. Tanganyika gölünden. Ciklet yumurtalarına kendi yumurtalarını karıştırır!',
      minLitre: 150,
      maxBoy: 12,
      sicaklik: { min: 24, max: 28 },
      ph: { min: 7.5, max: 9.0 },
      sertlik: { min: 10, max: 25 },
      yasam: '15-20 yıl',
      bolge: 'Alt',
      beslenme: 'Omnivor',
      uyumlu: ['Tanganyika cikletleri', 'Malawi cikletleri (dikkatli)'],
      uyumsuz: ['Yumuşak su balıkları'],
      ureme: 'Ağız kuluçkacı cikletlerin yumurtalarına kendi yumurtasını bırakır! (Brood parasitism)',
      eslesme: 'Çok benzersiz.',
      grupSayisi: '3+',
      disiErkek: 'Ayrımı zor.',
      gorunus: 'Bej-kahverengi üzerinde koyu kahverengi noktalar. S. lucipinnis ile karıştırılır.',
      kaynaklar: ['fishbase.org', 'planetcatfish.com']
    },
    {
      id: 'upside-down-catfish',
      isim: 'Ters Yüzen Kedi Balığı',
      latince: 'Synodontis nigriventris',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/7/76/Synodontis_nigriventris.jpg/1280px-Synodontis_nigriventris.jpg',
      zorluk: 'Kolay',
      genel: 'Ters yüzmeye adapte olmuş! Karın tarafı koyu (normal balıkların tersi). Kongo\'dan.',
      minLitre: 100,
      maxBoy: 10,
      sicaklik: { min: 22, max: 28 },
      ph: { min: 6.0, max: 8.0 },
      sertlik: { min: 5, max: 20 },
      yasam: '10-15 yıl',
      bolge: 'Orta ve Üst (ters!)',
      beslenme: 'Omnivor - Yüzen yemler dahil.',
      uyumlu: ['Barışçıl topluluk balıkları', 'Afrika cikletleri'],
      uyumsuz: ['Çok küçük balıklar'],
      ureme: 'Yumurtlayan.',
      eslesme: 'Mağaralarda.',
      grupSayisi: '3+ (sosyal)',
      disiErkek: 'Dişiler daha iri.',
      gorunus: 'Karın koyu, sırt açık renk (ters kamuflaj). Benekli desen.',
      kaynaklar: ['fishbase.org', 'planetcatfish.com']
    }
  ]
};

export const gokkusagiBaliklari = {
  kategori: {
    id: 'gokkusagi-baliklari',
    isim: 'Gökkuşağı Balıkları',
    emoji: '🌈',
    renk: '#4caf50',
    aciklama: 'Avustralya ve Yeni Gine rainbowfish türleri'
  },
  baliklar: [
    {
      id: 'boesemani-rainbow',
      isim: 'Boesemani Gökkuşağı',
      latince: 'Melanotaenia boesemani',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/7/7a/Melanotaenia_boesemani.jpg/1280px-Melanotaenia_boesemani.jpg',
      zorluk: 'Orta',
      genel: 'En popüler gökkuşağı balığı. Endonezya Ayamaru göllerinden. Erkeklerin iki tonlu rengi muhteşem.',
      minLitre: 200,
      maxBoy: 12,
      sicaklik: { min: 26, max: 30 },
      ph: { min: 7.0, max: 8.0 },
      sertlik: { min: 10, max: 20 },
      yasam: '5-8 yıl',
      bolge: 'Orta',
      beslenme: 'Omnivor',
      uyumlu: ['Diğer Rainbowfish', 'Barb', 'Tetra', 'Corydoras', 'Barışçıl cikletler'],
      uyumsuz: ['Çok küçük balıklar', 'Agresif türler'],
      ureme: 'Yumurtlayan. Bitki yapraklarına/mopa.',
      eslesme: 'Erkekler sabahları gösteriş yapar.',
      grupSayisi: '6+ (en az 2 dişi / erkek)',
      disiErkek: 'Erkekler çok daha renkli: ön yarı mavi, arka yarı sarı-turuncu. Dişiler soluk.',
      gorunus: 'İKİ TONLU: Ön yarı metalik mavi, arka yarı parlak sarı-turuncu. Gençler soluk, renk 1 yılda gelişir.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'turquoise-rainbow',
      isim: 'Turkuaz Gökkuşağı',
      latince: 'Melanotaenia lacustris',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/9/9d/Melanotaenia_lacustris.jpg/1280px-Melanotaenia_lacustris.jpg',
      zorluk: 'Orta',
      genel: 'Lake Kutubu Rainbow. Papua Yeni Gine\'den. Turkuaz mavi rengiyle çarpıcı.',
      minLitre: 150,
      maxBoy: 10,
      sicaklik: { min: 22, max: 26 },
      ph: { min: 7.0, max: 8.0 },
      sertlik: { min: 10, max: 20 },
      yasam: '5-8 yıl',
      bolge: 'Orta',
      beslenme: 'Omnivor',
      uyumlu: ['Diğer Rainbowfish', 'Barışçıl topluluk balıkları'],
      uyumsuz: ['Agresif türler'],
      ureme: 'Yumurtlayan.',
      eslesme: 'Sabah gösterişi.',
      grupSayisi: '6+',
      disiErkek: 'Erkekler daha renkli ve derin vücutlu.',
      gorunus: 'Parlak turkuaz-mavi vücut, sarı-yeşil tonlar. Çift sırt yüzgeci.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'red-rainbow',
      isim: 'Kırmızı Gökkuşağı',
      latince: 'Glossolepis incisus',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/0/06/Glossolepis_incisus.jpg/1280px-Glossolepis_incisus.jpg',
      zorluk: 'Orta',
      genel: 'Red Salmon Rainbow. Papua Yeni Gine\'den. Erkekler parlak kırmızı olur.',
      minLitre: 200,
      maxBoy: 15,
      sicaklik: { min: 24, max: 28 },
      ph: { min: 7.0, max: 8.0 },
      sertlik: { min: 10, max: 20 },
      yasam: '5-8 yıl',
      bolge: 'Orta',
      beslenme: 'Omnivor',
      uyumlu: ['Diğer Rainbowfish', 'Büyük Barb', 'Barışçıl cikletler'],
      uyumsuz: ['Küçük balıklar'],
      ureme: 'Yumurtlayan.',
      eslesme: 'Erkekler kırmızılaşır ve gösteriş yapar.',
      grupSayisi: '6+',
      disiErkek: 'Erkekler parlak kırmızı, yüksek arkalı. Dişiler zeytini-gümüşi.',
      gorunus: 'Erkekler tamamen parlak kırmızı, arkaları yüksek. Dişiler zeytin yeşili-gümüşi.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'australian-rainbow',
      isim: 'Avustralya Gökkuşağı',
      latince: 'Melanotaenia splendida',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/c/c7/Melanotaenia_splendida.jpg/1280px-Melanotaenia_splendida.jpg',
      zorluk: 'Kolay',
      genel: 'Kuzey Avustralya\'dan. Birçok alt tür. Dayanıklı ve uyumlu.',
      minLitre: 150,
      maxBoy: 12,
      sicaklik: { min: 22, max: 28 },
      ph: { min: 6.5, max: 8.0 },
      sertlik: { min: 5, max: 20 },
      yasam: '5-8 yıl',
      bolge: 'Orta',
      beslenme: 'Omnivor',
      uyumlu: ['Diğer Rainbowfish', 'Çoğu topluluk balığı'],
      uyumsuz: ['Çok küçük balıklar'],
      ureme: 'Yumurtlayan.',
      eslesme: 'Kolay ürer.',
      grupSayisi: '6+',
      disiErkek: 'Erkekler daha renkli.',
      gorunus: 'Lokasyona göre çok farklı renkler. Mavi, yeşil, kırmızı, sarı kombinasyonları.',
      kaynaklar: ['fishbase.org']
    },
    {
      id: 'threadfin-rainbow',
      isim: 'Threadfin Gökkuşağı',
      latince: 'Iriatherina werneri',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/59/Iriatherina_werneri.jpg/1280px-Iriatherina_werneri.jpg',
      zorluk: 'Orta',
      genel: 'Featherfin Rainbow. Çok zarif, iplik gibi yüzgeç uzantıları. Nano-orta tanklar için.',
      minLitre: 80,
      maxBoy: 5,
      sicaklik: { min: 24, max: 30 },
      ph: { min: 6.0, max: 7.5 },
      sertlik: { min: 5, max: 15 },
      yasam: '3-5 yıl',
      bolge: 'Orta ve Üst',
      beslenme: 'Omnivor - Küçük yemler.',
      uyumlu: ['Küçük barışçıl balıklar', 'Diğer küçük Rainbowfish'],
      uyumsuz: ['Yüzgeç ısırıcılar', 'Büyük balıklar'],
      ureme: 'Yumurtlayan.',
      eslesme: 'Erkekler iplik yüzgeçlerini açarak gösteriş yapar.',
      grupSayisi: '6+ (daha fazla dişi)',
      disiErkek: 'Erkeklerin yüzgeçlerinde çok uzun iplik uzantılar.',
      gorunus: 'İnce, zarif. Erkeklerin sırt ve anal yüzgeçlerinde çok uzun siyah iplikler. Sarı-yeşil vücut.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'pseudomugil-gertrudae',
      isim: 'Spotted Blue-eye',
      latince: 'Pseudomugil gertrudae',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/8/8a/Pseudomugil_gertrudae.jpg/1280px-Pseudomugil_gertrudae.jpg',
      zorluk: 'Orta',
      genel: 'Gertrude\'s Rainbowfish. Çok küçük, mavi gözlü. Nano tanklar için mükemmel.',
      minLitre: 40,
      maxBoy: 3,
      sicaklik: { min: 24, max: 30 },
      ph: { min: 6.0, max: 7.5 },
      sertlik: { min: 5, max: 15 },
      yasam: '2-3 yıl',
      bolge: 'Orta ve Üst',
      beslenme: 'Omnivor - Küçük yemler.',
      uyumlu: ['Nano balıklar', 'Karides'],
      uyumsuz: ['Büyük balıklar', 'Hızlı yem rakipleri'],
      ureme: 'Yumurtlayan.',
      eslesme: 'Erkekler gösteriş yapar.',
      grupSayisi: '6+',
      disiErkek: 'Erkekler daha renkli, sarı yüzgeçler.',
      gorunus: 'Minik. Parlak mavi gözler. Sarı-turuncu yüzgeçler, benekli vücut.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    }
  ]
};

export const killifish = {
  kategori: {
    id: 'killifish',
    isim: 'Killifish',
    emoji: '🔥',
    renk: '#f44336',
    aciklama: 'Yumurtlayan dişli sazangiller - Renkli ve ilginç üreme davranışları'
  },
  baliklar: [
    {
      id: 'golden-wonder-killifish',
      isim: 'Golden Wonder Killifish',
      latince: 'Aplocheilus lineatus',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/3/3e/Aplocheilus_lineatus.jpg/1280px-Aplocheilus_lineatus.jpg',
      zorluk: 'Kolay',
      genel: 'Striped Panchax. Hindistan\'dan. Yüzey avcısı - küçük balıkları yer! En kolay killifish.',
      minLitre: 100,
      maxBoy: 10,
      sicaklik: { min: 22, max: 28 },
      ph: { min: 6.0, max: 7.5 },
      sertlik: { min: 5, max: 15 },
      yasam: '3-5 yıl',
      bolge: 'Üst',
      beslenme: 'Karnivor - Böcek, canlı yem, yüzen pellet.',
      uyumlu: ['Orta-büyük boy dip/orta balıkları'],
      uyumsuz: ['Küçük balıklar (YER!)', 'Diğer yüzey balıkları'],
      ureme: 'Yumurtlayan. Bitki köplerine.',
      eslesme: 'Çift, yumurtalar birkaç hafta içinde çıkar.',
      grupSayisi: '1 erkek / 2-3 dişi',
      disiErkek: 'Erkekler daha parlak sarı, kırmızı yüzgeç detayları.',
      gorunus: 'Altın sarısı vücut (Gold form). Yeşilimsi çizgiler. Doğal formda da mevcut.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'clown-killifish',
      isim: 'Clown Killifish',
      latince: 'Epiplatys annulatus',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/0/0a/Epiplatys_annulatus.jpg/1280px-Epiplatys_annulatus.jpg',
      zorluk: 'Orta',
      genel: 'Rocket Killifish. Batı Afrika\'dan. Çok küçük, renkli. Nano tanklarda popüler.',
      minLitre: 30,
      maxBoy: 4,
      sicaklik: { min: 22, max: 26 },
      ph: { min: 6.0, max: 7.0 },
      sertlik: { min: 3, max: 10 },
      yasam: '3-5 yıl',
      bolge: 'Üst',
      beslenme: 'Karnivor - Küçük canlı/dondurulmuş yem.',
      uyumlu: ['Küçük barışçıl balıklar', 'Karides'],
      uyumsuz: ['Büyük balıklar', 'Yüzey rakipleri'],
      ureme: 'Yumurtlayan. Yüzen bitkilere.',
      eslesme: 'Sürekli yumurtlar.',
      grupSayisi: '1 erkek / 2 dişi',
      disiErkek: 'Erkekler daha renkli, mavi-kırmızı kuyruk.',
      gorunus: 'Küçük, torpedo şekilli. Dikey koyu bantlar. Erkeklerin kuyruğu mavi-kırmızı alev şeklinde.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'gardneri-killifish',
      isim: 'Gardneri Killifish',
      latince: 'Fundulopanchax gardneri',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/e/e9/Fundulopanchax_gardneri.jpg/1280px-Fundulopanchax_gardneri.jpg',
      zorluk: 'Orta',
      genel: 'Steel Blue Killifish. Nijerya\'dan. Birçok lokasyon varyantı. Renkli ve nispeten dayanıklı.',
      minLitre: 60,
      maxBoy: 7,
      sicaklik: { min: 22, max: 26 },
      ph: { min: 6.0, max: 7.0 },
      sertlik: { min: 3, max: 10 },
      yasam: '3-5 yıl',
      bolge: 'Üst ve Orta',
      beslenme: 'Karnivor - Canlı/dondurulmuş yem tercih.',
      uyumlu: ['Küçük barışçıl balıklar', 'Diğer barışçıl Killifish'],
      uyumsuz: ['Çok küçük balıklar', 'Agresif türler'],
      ureme: 'Yumurtlayan. Mop veya torfa.',
      eslesme: 'Erkekler gösteriş yapar.',
      grupSayisi: '1 erkek / 2-3 dişi',
      disiErkek: 'Erkekler çok renkli: mavi-yeşil vücut, kırmızı noktalar. Dişiler kahverengi.',
      gorunus: 'Erkekler muhteşem: metalik mavi-yeşil, kırmızı noktalar, sarı-kırmızı kuyruk. Lokasyona göre farklılık.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'nothobranchius-rachovii',
      isim: 'Rachovi Killifish',
      latince: 'Nothobranchius rachovii',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/8/89/Nothobranchius_rachovii_male.jpg/1280px-Nothobranchius_rachovii_male.jpg',
      zorluk: 'Zor',
      genel: 'Bluefin Notho. Mozambik\'ten. YILLIK balık - doğada su kuruyor, yumurtalar toprakta bekliyor!',
      minLitre: 40,
      maxBoy: 6,
      sicaklik: { min: 20, max: 24 },
      ph: { min: 6.0, max: 7.0 },
      sertlik: { min: 3, max: 10 },
      yasam: '1-2 yıl (yıllık!)',
      bolge: 'Alt ve Orta',
      beslenme: 'Karnivor - Canlı/dondurulmuş yem.',
      uyumlu: ['Diğer Nothobranchius (dikkatli)'],
      uyumsuz: ['Uzun ömürlü balıklar (plan uyumsuzluğu)'],
      ureme: 'Torf yumurtlayıcı. Yumurtalar kuru tortta aylarca bekler.',
      eslesme: 'Erkekler hızla ürer - kısa ömür!',
      grupSayisi: '1 erkek / 2 dişi',
      disiErkek: 'Erkekler muhteşem renkli. Dişiler kahverengi.',
      gorunus: 'Erkekler: turuncu-kırmızı vücut, mavi desenler, mavi kenar. En renkli killifish\'lerden!',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'aphyosemion-australe',
      isim: 'Lyretail Killifish',
      latince: 'Aphyosemion australe',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/c/c4/Aphyosemion_australe_gold.jpg/1280px-Aphyosemion_australe_gold.jpg',
      zorluk: 'Orta',
      genel: 'Cape Lopez Lyretail. Gabon\'dan. Lir şeklinde kuyruk. Yıllık değil, daha uzun ömürlü.',
      minLitre: 40,
      maxBoy: 6,
      sicaklik: { min: 20, max: 24 },
      ph: { min: 6.0, max: 7.0 },
      sertlik: { min: 3, max: 10 },
      yasam: '3-5 yıl',
      bolge: 'Orta ve Üst',
      beslenme: 'Karnivor - Canlı/dondurulmuş yem.',
      uyumlu: ['Küçük barışçıl balıklar'],
      uyumsuz: ['Büyük balıklar', 'Yüzgeç ısırıcılar'],
      ureme: 'Yumurtlayan. Mopa veya bitkilere.',
      eslesme: 'Erkekler gösteriş yapar.',
      grupSayisi: '1 erkek / 2 dişi',
      disiErkek: 'Erkekler renkli, lir kuyruklu. Dişiler daha soluk.',
      gorunus: 'Chocolate (kahverengi-turuncu) ve Orange (sarı-turuncu) formları popüler. Lir şeklinde kuyruk.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    }
  ]
};

export const digerTurler = {
  kategori: {
    id: 'diger-turler',
    isim: 'Diğer Türler',
    emoji: '🐟',
    renk: '#607d8b',
    aciklama: 'Diğer tatlı su akvaryum balıkları'
  },
  baliklar: [
    {
      id: 'japon-baligi',
      isim: 'Japon Balığı (Goldfish)',
      latince: 'Carassius auratus',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/e/e9/Goldfish3.jpg/1280px-Goldfish3.jpg',
      zorluk: 'Kolay',
      genel: 'Dünyanın en eski evcil balığı (1000+ yıl). Çin\'de evcilleştirildi. Soğuk su balığı - ısıtıcı gerektirmez.',
      minLitre: 150,
      maxBoy: 30,
      sicaklik: { min: 10, max: 24 },
      ph: { min: 6.5, max: 8.0 },
      sertlik: { min: 5, max: 20 },
      yasam: '10-15 yıl (bakımlı 30+ yıl!)',
      bolge: 'Tüm bölgeler',
      beslenme: 'Omnivor - Goldfish peleti, sebze, canlı yem.',
      uyumlu: ['Diğer Goldfish', 'Beyaz Bulut', 'Dojo Loach', 'Soğuk su balıkları'],
      uyumsuz: ['Tropikal balıklar (sıcaklık)', 'Küçük balıklar (yer)', 'Yüzgeç ısırıcılar'],
      ureme: 'Yumurtlayan. Bahar/yaz.',
      eslesme: 'Erkekler dişileri kovalar.',
      grupSayisi: '2+',
      disiErkek: 'Üreme döneminde erkeklerin solungaklarında beyaz tüberküller.',
      gorunus: 'Common, Comet, Shubunkin, Fantail, Oranda, Ryukin, Black Moor, Ranchu gibi yüzlerce varyasyon.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'axolotl',
      isim: 'Axolotl (Meksika Sucul Semenderi)',
      latince: 'Ambystoma mexicanum',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/f/f6/Axolotl_ganz.jpg/1280px-Axolotl_ganz.jpg',
      zorluk: 'Orta',
      genel: 'Balık DEĞİL, amfibi! Neotenik - larvadayken kalır, karada yaşamaz. Meksika\'da nesli tehlike altında.',
      minLitre: 150,
      maxBoy: 30,
      sicaklik: { min: 14, max: 20 },
      ph: { min: 6.5, max: 8.0 },
      sertlik: { min: 7, max: 14 },
      yasam: '10-15 yıl',
      bolge: 'Alt',
      beslenme: 'Karnivor - Solucan, kan kurdu, özel peletler. CANLI YEM SEVER.',
      uyumlu: ['HİÇBİRİ - tek veya kendi türü'],
      uyumsuz: ['Tüm balıklar (solungaç ısırma veya yenir)'],
      ureme: 'Spermatofor ile iç döllenme.',
      eslesme: 'Erkek spermatofor bırakır, dişi alır.',
      grupSayisi: 'Tek veya aynı boy eşleri',
      disiErkek: 'Erkeklerin kloaka şişkinliği var.',
      gorunus: 'Dış solungaçlar, gülümseyen yüz. Wildtype (siyah-kahverengi), Leucistic (beyaz-pembe), Albino, Melanoid, GFP.',
      kaynaklar: ['caudata.org']
    },
    {
      id: 'african-dwarf-frog',
      isim: 'Afrika Cüce Kurbağası',
      latince: 'Hymenochirus boettgeri',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/d/da/Hymenochirus_boettgeri.jpg/1280px-Hymenochirus_boettgeri.jpg',
      zorluk: 'Kolay',
      genel: 'Tamamen suda yaşayan kurbağa. Batı Afrika\'dan. Balık değil ama popüler akvaryum sakini.',
      minLitre: 40,
      maxBoy: 4,
      sicaklik: { min: 24, max: 28 },
      ph: { min: 6.5, max: 7.5 },
      sertlik: { min: 5, max: 15 },
      yasam: '5-10 yıl',
      bolge: 'Alt (nefes için yüzeye)',
      beslenme: 'Karnivor - Dondurulmuş yem, bloodworm, brine shrimp.',
      uyumlu: ['Barışçıl küçük balıklar', 'Tetralar', 'Corydoras'],
      uyumsuz: ['Büyük balıklar', 'Agresif türler'],
      ureme: 'Yumurtlayan.',
      eslesme: 'Amplexus ile.',
      grupSayisi: '2+',
      disiErkek: 'Erkeklerde koltuk altında bez.',
      gorunus: 'Küçük, kahverengi-yeşil benekli. Perdeli ayaklar. African CLAWED Frog ile karıştırma (o çok büyük)!',
      kaynaklar: ['amphibiancare.com']
    },
    {
      id: 'freshwater-pufferfish',
      isim: 'Tatlı Su Balon Balığı',
      latince: 'Carinotetraodon travancoricus',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/9/95/Carinotetraodon_travancoricus.jpg/1280px-Carinotetraodon_travancoricus.jpg',
      zorluk: 'Orta',
      genel: 'Pea Puffer, Dwarf Puffer. Hindistan\'dan. En küçük balon balığı. Salyangoz AVCISI!',
      minLitre: 40,
      maxBoy: 3,
      sicaklik: { min: 24, max: 28 },
      ph: { min: 6.5, max: 7.5 },
      sertlik: { min: 5, max: 15 },
      yasam: '4-5 yıl',
      bolge: 'Tüm bölgeler',
      beslenme: 'Karnivor - Salyangoz (diş aşındırma!), dondurulmuş yem, canlı yem.',
      uyumlu: ['Çok dikkatli - genelde TEK!', 'Otocinclus bazen'],
      uyumsuz: ['Yüzgeç ısırır!', 'Yavaş balıklar', 'Uzun yüzgeçli balıklar', 'Salyangoz (yem)'],
      ureme: 'Yumurtlayan.',
      eslesme: 'Erkek bölge kurar.',
      grupSayisi: 'TEK veya 1 erkek / 2-3 dişi (büyük tank)',
      disiErkek: 'Erkeklerde koyu karın çizgisi ve göz arkasında kırışıklık.',
      gorunus: 'Minik, şişebilir (stresli olunca). Sarı-yeşil üzerinde koyu benekler. Çok meraklı bakış.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'kuhli-loach',
      isim: 'Kuhli Yılanbalığı',
      latince: 'Pangio kuhlii',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/4/4e/Kuhli_loach.jpg/1280px-Kuhli_loach.jpg',
      zorluk: 'Kolay',
      genel: 'Yılan gibi uzun. Endonezya ve Malezya\'dan. Gece aktif, kuma gömülür. Dip temizleyici.',
      minLitre: 60,
      maxBoy: 10,
      sicaklik: { min: 24, max: 30 },
      ph: { min: 5.5, max: 7.0 },
      sertlik: { min: 1, max: 10 },
      yasam: '10+ yıl',
      bolge: 'Alt',
      beslenme: 'Omnivor - Dip yemler, batan pellet, canlı/dondurulmuş yem.',
      uyumlu: ['Küçük barışçıl balıklar', 'Tetralar', 'Rasbora', 'Corydoras'],
      uyumsuz: ['Büyük/agresif balıklar', 'Sivri çakıl (yaralanır)'],
      ureme: 'Yumurtlayan. Akvaryumda çok nadir.',
      eslesme: '-',
      grupSayisi: '5+ (sosyal, grup halinde daha aktif)',
      disiErkek: 'Ayrımı zor. Dişiler daha dolgun.',
      gorunus: 'Uzun, yılan benzeri vücut. Sarı-turuncu üzerinde kahverengi bantlar. Gömülebilir.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'hillstream-loach',
      isim: 'Hillstream Yılanbalığı',
      latince: 'Sewellia lineolata',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/Sewellia_lineolata.jpg/1280px-Sewellia_lineolata.jpg',
      zorluk: 'Orta',
      genel: 'Reticulated Hillstream Loach. Vietnam\'dan. Yüksek akıntı ve oksijenli su gerektirir.',
      minLitre: 100,
      maxBoy: 7,
      sicaklik: { min: 18, max: 24 },
      ph: { min: 6.5, max: 7.5 },
      sertlik: { min: 5, max: 15 },
      yasam: '8-10 yıl',
      bolge: 'Alt (kayalara yapışık)',
      beslenme: 'Herbivor - Alg, spirulina, blanched sebze.',
      uyumlu: ['Soğuk su balıkları', 'Beyaz Bulut', 'Danio', 'Diğer akıntı balıkları'],
      uyumsuz: ['Sıcak tropikal balıklar', 'Düşük oksijenli ortam'],
      ureme: 'Yumurtlayan. Akvaryumda zor.',
      eslesme: 'Yüksek akıntı gerekir.',
      grupSayisi: '3+ (sosyal)',
      disiErkek: 'Erkeklerin kafalında tüberküller.',
      gorunus: 'Yassı, disk şekilli. Vantuz benzeri vücut. Güzel ağ deseni. Cama/kayaya yapışır.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'clown-loach',
      isim: 'Palyaço Yılanbalığı',
      latince: 'Chromobotia macracanthus',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/c/c7/Clown_loach.jpg/1280px-Clown_loach.jpg',
      zorluk: 'Orta',
      genel: 'UYARI: 30cm+ olur! Mağazada küçük ama DEV olur. Sosyal - en az 5. Salyangoz yiyici.',
      minLitre: 500,
      maxBoy: 30,
      sicaklik: { min: 26, max: 30 },
      ph: { min: 6.0, max: 7.5 },
      sertlik: { min: 5, max: 15 },
      yasam: '20+ yıl',
      bolge: 'Alt',
      beslenme: 'Omnivor - Salyangoz, dip tablet, canlı yem.',
      uyumlu: ['Diğer Clown Loach', 'Büyük barışçıl balıklar', 'Barb', 'Tetra'],
      uyumsuz: ['Küçük tanklar!', 'Tek tutma (stres)', 'Agresif cikletler'],
      ureme: 'Akvaryumda üremez.',
      eslesme: '-',
      grupSayisi: '5+ (SOSYAL, tek strese girer!)',
      disiErkek: 'Ayrımı çok zor.',
      gorunus: 'Turuncu üzerinde siyah bantlar. Palyaço renkleri. DİKENLİ göz altı!',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'yoyo-loach',
      isim: 'Yoyo Yılanbalığı',
      latince: 'Botia almorhae',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/4/4e/Botia_almorhae.jpg/1280px-Botia_almorhae.jpg',
      zorluk: 'Kolay',
      genel: 'Pakistani Loach. Deseni "YOYO" harflerine benzer. Salyangoz yiyici. Clown Loach\'tan küçük.',
      minLitre: 150,
      maxBoy: 13,
      sicaklik: { min: 24, max: 28 },
      ph: { min: 6.5, max: 7.5 },
      sertlik: { min: 5, max: 15 },
      yasam: '5-10 yıl',
      bolge: 'Alt',
      beslenme: 'Omnivor - Salyangoz!, dip tablet, canlı yem.',
      uyumlu: ['Diğer Loach', 'Barb', 'Tetra', 'Barışçıl topluluk balıkları'],
      uyumsuz: ['Küçük balıklar', 'Tek tutma'],
      ureme: 'Akvaryumda çok nadir.',
      eslesme: '-',
      grupSayisi: '4+ (sosyal)',
      disiErkek: 'Dişiler daha tombul.',
      gorunus: 'Gri-gümüşi üzerinde koyu labirent deseni - "YOYO" harflerine benzer.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    },
    {
      id: 'dojo-loach',
      isim: 'Dojo Yılanbalığı',
      latince: 'Misgurnus anguillicaudatus',
      resim: 'https://upload.wikimedia.org/wikipedia/commons/thumb/8/8e/Misgurnus_anguillicaudatus.jpg/1280px-Misgurnus_anguillicaudatus.jpg',
      zorluk: 'Kolay',
      genel: 'Weather Loach - hava basıncı değişimlerine tepki verir! Doğu Asya\'dan. Soğuğa toleranslı.',
      minLitre: 150,
      maxBoy: 25,
      sicaklik: { min: 10, max: 24 },
      ph: { min: 6.5, max: 8.0 },
      sertlik: { min: 5, max: 20 },
      yasam: '10+ yıl',
      bolge: 'Alt',
      beslenme: 'Omnivor - Dip yemler, solucan, sebze.',
      uyumlu: ['Goldfish', 'Soğuk su balıkları', 'Beyaz Bulut', 'Barışçıl balıklar'],
      uyumsuz: ['Sıcak tropikal balıklar'],
      ureme: 'Yumurtlayan. Akvaryumda zor.',
      eslesme: '-',
      grupSayisi: '3+',
      disiErkek: 'Erkeklerin göğüs yüzgeçleri daha büyük.',
      gorunus: 'Uzun, yılan benzeri. Sarı-kahverengi, bazen benekli. Gold formuve albino popüler.',
      kaynaklar: ['fishbase.org', 'seriouslyfish.com']
    }
  ]
};

export default { sazansigiller, kediBaliklari, gokkusagiBaliklari, killifish, digerTurler };